import React from 'react';
import { formatAttributeValue, getOmdAttributes, type OmdProduct } from '../../../utils/omdProductView';

export function OmdEtimTable({ product }: { product: OmdProduct }) {
  const attrs = getOmdAttributes(product);
  if (attrs.length === 0) return null;

  return (
    <div className="overflow-x-auto rounded-lg border border-app-border">
      <table className="min-w-full text-sm">
        <thead>
          <tr className="bg-app-surface-muted border-b border-app-border">
            <th className="px-3 py-2 text-left text-xs font-semibold text-app-text-muted">Merkmal</th>
            <th className="px-3 py-2 text-left text-xs font-semibold text-app-text-muted">Wert</th>
            <th className="px-3 py-2 text-left text-xs font-semibold text-app-text-muted">System</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-app-border">
          {attrs.map((attr, idx) => (
            <tr key={`${attr.attributeName}-${idx}`}>
              <td className="px-3 py-2 text-app-text">{attr.attributeName || '-'}</td>
              <td className="px-3 py-2 text-app-text font-medium">{formatAttributeValue(attr) || '-'}</td>
              <td className="px-3 py-2">
                {attr.attributeSystem ? (
                  <span className="inline-flex px-1.5 py-0.5 rounded bg-app-surface-muted text-xs font-medium text-app-text-muted">
                    {attr.attributeSystem}
                  </span>
                ) : (
                  '-'
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
